import React from "react";
import './input.scss'

const Error = ({value, style = {}}) => {
    return (
        <div style={{marginBottom: '15px', ...style}} className={'error-validate'}>{value}</div>
    )
}
export default Error
